/**
 * @fileoverview Patches binky's floodgate client to include new headers (x-gw-ims-org-id, x-sandbox-name)
 * required by the Floodgate v3 API. This override wraps the existing binky floodgate client instead
 * of requiring a full binky version upgrade.
 */

/* global require */

// Import axios for making HTTP requests
var _ = require('lodash');
var axios = require('axios');

(function patchFloodgate() {
  // This will be called after binky is loaded via the bundle
  var floodgate = _.get(window, 'binkySrc2.api.floodgate');
  var authService = _.get(window, 'binkySrc2.services.authentication');

  if (!floodgate) {
    // eslint-disable-next-line no-console
    console.error(
      '[floodgate-override] binky floodgate client not found; headers will not be patched.'
    );
    return;
  }

  var originalConfigure = floodgate.configure;

  var baseUrl,
   clientId,
   orgId,
   sandboxName;

  /**
   * Override configure to capture orgId and sandboxName
   * @param {Object} configParam - Configuration object
   * @param {string} configParam.url - Base URL for floodgate service
   * @param {string} configParam.clientId - Client ID for API key header
   * @param {string} [configParam.orgId] - IMS Org ID for x-gw-ims-org-id header
   * @param {string} [configParam.sandboxName] - Sandbox name for x-sandbox-name header
   * @returns {*} Result from original configure call
   */
  floodgate.configure = function configure(configParam) {
    var config = configParam || {};
    clientId = config.clientId;
    baseUrl = config.url + '/feature';
    orgId = config.orgId;
    sandboxName = config.sandboxName;

    // Call original configure to maintain backward compatibility
    return originalConfigure.call(this, config);
  };

  /**
   * Build headers for the floodgate request
   * @returns {Object} Headers object
   */
  function buildHeaders() {
    var headers = {
      'Content-Type': 'application/json',
      'X-Api-Key': clientId,
    };

    // Add new API headers if available
    if (orgId) {
      headers['x-gw-ims-org-id'] = orgId;
    }
    if (sandboxName) {
      headers['x-sandbox-name'] = sandboxName;
    }

    // Add authentication token
    var token = _.get(authService, 'getAccessToken') && authService.getAccessToken();
    if (token && token.token) {
      headers.Authorization = 'Bearer ' + token.token;
    }

    return headers;
  }

  /**
   * Override getReleases to add new headers
   * @param {Object} [optionsParam] - Options object
   * @param {Object} [optionsParam.queryParams] - Query parameters to append to the request
   * @returns {Promise<Object>} Promise resolving to floodgate response data
   */
  floodgate.getReleases = function getReleases(optionsParam) {
    var options = optionsParam || {};
    var queryParams = options.queryParams || {};

    if (!clientId || !baseUrl) {
      // eslint-disable-next-line no-console
      console.error('[floodgate-override] floodgate client not configured before getReleases().');
      throw new Error('Floodgate client not configured. Call configure() first.');
    }

    var headers = buildHeaders();

    // Build URL with query parameters
    var search = new URLSearchParams({clientId});
    _(queryParams).keys().forEach(function(key) {
      var value = queryParams[key];
      if (!_.isNil(value)) {
        search.append(key, String(value));
      }
    });

    var url = baseUrl + '?' + search.toString();

    return axios.get(url, {
      headers,
      timeout: 5000,
    }).then(function(response) {
      return response.data;
    }).catch(function(error) {
      // eslint-disable-next-line no-console
      console.error('[floodgate-override] Error fetching releases:', error);
      throw error;
    });
  };

  // eslint-disable-next-line no-console
  console.log(
    '[floodgate-override] Successfully patched binky floodgate client with new headers support.'
  );
})();

